/* eslint-disabled */
import Branch from "./Branch";
import PremiumDetail from "./PremiumDetail";
import EngineMethod from "./EngineMethod";
import PremiumDetailModelExtend from "@/entity/extends/PremiumDetailModelExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class PremiumDetailModel extends PremiumDetailModelExtend {

    public id!: number;
    public label = '';
    public operator? = '';
    public branch!: Branch;
    public premiumDetails: Array<PremiumDetail> = [];
    public method?: EngineMethod;
    public ranking?: number;
    public code: string = ''
    public isReduction = false
    public isEnabled = true

    constructor(object?: any) {
        super(object)
        if (object) {
            this.id = object.id;
            this.label = object.label;
            this.isReduction = object.isReduction;
            this.operator = object.operator;
            this.code = object.code;
            this.isEnabled = object.isEnabled;
            this.branch = (object.branch instanceof Branch) ? object.branch : object.branch ? new Branch(object.branch) : object.branch;
            hydrateCollection(object.premiumDetails, PremiumDetail, this.premiumDetails);
            this.method = (object.method instanceof EngineMethod) ? object.method : object.method ? new EngineMethod(object.method) : object.method;
            this.ranking = object.ranking;
        }
        this.postConstruct()
    }
}
